(function () {

    var directive = function (screenShotStoreSrvc, $rootScope, constants) {
        return {
            restrict: 'E',
            templateUrl: './app/views/screenshot-button.html',
            replace: true,
            scope: {
                menuRight: '=',
                format: '@',
                dropup: '@',
                step: '@'
            },
            link: function postLink(scope, element, attrs) {
                $rootScope.$on('initScreenshotArray', function () {
                    scope.screenshots = screenShotStoreSrvc.getScreenshotForStep(scope.step);
                    scope.selected = (scope.screenshots.length > 0) ? scope.screenshots[0] : '';
                });
            },
            controller: ['$scope', 'ngDialog', 'Scene2d', 'SocialShare', 'screenShotStoreSrvc',
            'AuthenticationService', 'ResourceService', 'toastr', '$rootScope', 'printService',
            'screenshotPreprocess', 'scene3DScreenshotSrvc', 'aiSnapshotConstants', 'constants',
            'localStorageService',
                function ($scope, ngDialog, Scene2d, SocialShare,
                  screenShotStoreSrvc, AuthenticationService, ResourceService, toastr, $rootScope,
                  printService, screenshotPreprocess, scene3DScreenshotSrvc, aiSnapshotConstants, constants,
                  localStorageService) {
                    $scope.url = constants.API_URL;
                    $scope.screenshots = [];
                    $scope.selected = $scope.screenshots[0];
                    $scope.generateAiLoading = false;

                    function getApiErrorMessage(error, fallback) {
                        if (error && error.data && error.data.error) {
                            if (typeof error.data.error === 'string') {
                                return error.data.error;
                            }

                            return error.data.error.message || fallback;
                        }

                        return fallback;
                    }


                    $rootScope.$on('reset', function () {
                        $scope.screenshots = [];
                        $scope.selected = ($scope.screenshots.length > 0) ? $scope.screenshots[0] : '';
                    });

                    $scope.selectScreenshot = function (screenshot) {
                        $scope.selected = screenshot;
                    };
                    $rootScope.loadScreenshotStep = function (step) {
                        $scope.screenshots = screenShotStoreSrvc.getScreenshotForStep(step);
                        $scope.selected = ($scope.screenshots.length > 0) ? $scope.screenshots[0] : '';
                    };

                    $scope.takeScreenshot = function () {
                        var screenshot;
                        if ($scope.format === 'two-dimensional') {
                            screenshot = screenshotPreprocess.clipEmptySpace2D(Scene2d.getSnapShots());
                        }
                        else {
                            screenshot = scene3DScreenshotSrvc.take();
                        }
                        if (AuthenticationService.publisher()) {
                            ResourceService.TemplateScreenShotSaveToUploads(screenshot).then(function (data) {
                                console.log('image save');
                                $scope.screenshots = screenShotStoreSrvc.pushScreenshotToStep($scope.step, data.url);
                                $scope.selected = $scope.screenshots[0];
                            },
                                function (error) {
                                    toastr.error(error);
                                });
                        }
                        else {
                            ResourceService.screenShotSaveToUploads(screenshot).then(function (data) {
                                console.log('image save');
                                $scope.screenshots = screenShotStoreSrvc.pushScreenshotToStep($scope.step, data.url);
                                $scope.selected = $scope.screenshots[0];
                            },
                                function (error) {
                                    toastr.error(error);
                                });
                        }
                    };

                    $scope.deleteScreenshot = function () {
                        var index = $scope.screenshots.indexOf($scope.selected),
                            newIndex = index - 1;                     
                        let room_id = $rootScope.editedRoomData?._id;
                        ResourceService.screenshotDelete($scope.screenshots[index].image.slice(20, 33), $scope.step, room_id).then(function (data) {
                            $scope.screenshots.splice(index, 1);
                            screenShotStoreSrvc.deleteScreenshotFromStep($scope.step, $scope.screenshots);
                            newIndex = newIndex < 0 ? 0 : newIndex;
                            $scope.selected = $scope.screenshots[newIndex];
                        },
                            function (error) {
                                toastr.error(error);
                            });

                    };

                    $scope.OpenSocialShare = function () {
                        //console.log($scope.selected);
                        SocialShare.share($scope.selected.image);
                    };

                    $scope.slide = function (direction, e) {
                        var screenshotsContainer = e.delegateTarget.parentElement.parentElement.children[1];
                        screenshotsContainer.scrollLeft += 70 * direction;
                    };

                    $scope.goFullScreen = function () {
                        var elem = document.getElementById("screenshot");
                        if (elem.requestFullscreen) {
                            elem.requestFullscreen();
                        } else if (elem.msRequestFullscreen) {
                            elem.msRequestFullscreen();
                        } else if (elem.mozRequestFullScreen) {
                            elem.mozRequestFullScreen();
                        } else if (elem.webkitRequestFullscreen) {
                            elem.webkitRequestFullscreen();
                        }
                    }

                    $scope.switch = function (direction) {
                        var currentIndex = $scope.screenshots.indexOf($scope.selected),
                            newIndex = currentIndex + direction;
                        if (newIndex >= 0 && newIndex <= $scope.screenshots.length - 1)
                            $scope.selected = $scope.screenshots[newIndex];
                    };

                    $scope.viewScreenshots = function () {
                        // The ribbon renders newest-first, so the first image on
                        // screen is the last one in the store - always open the
                        // popup with it selected.
                        if ($scope.screenshots.length > 0) {
                            $scope.selected = $scope.screenshots[$scope.screenshots.length - 1];
                        }
                        ngDialog.open({
                            scope: $scope,
                            disableAnimation: true,
                            className: 'ngdialog-theme-default screenshots-popup',
                            template: './app/views/screenshotsPopUp.html'
                        });
                    };

                    $scope.printScreenshot = function(){
                      var screenshotSrc = angular.element("#screenshot")[0].src;
                      var html = '<html><head><link rel="stylesheet" href="styles/forPrint.css">'
                      html+='</head>';
                      html+='<body><img id = "screenshot" src="'+screenshotSrc+'" alt="Akro-Mils"/>';
                      html+='</body></html>';
                      printService.createPrintPopup(html);
                    };

                    // Prompt/model settings are for admins only: the publisher
                    // (Template Master) or the adminSale role. Evaluated as a
                    // function so the gear appears right after an in-place login.
                    $scope.isAiSettingsAdmin = function () {
                        return (
                            AuthenticationService.publisher() === true ||
                            AuthenticationService.role() === constants.roles.adminSale
                        );
                    };

                    // AI generation is for signed-in users only. The button stays
                    // visible; an anonymous click opens a login dialog instead of
                    // navigating to /login, so the current planner step is kept.
                    function openAiLoginDialog() {
                        var loginScope = $scope.$new(true);

                        loginScope.loginData = { email: '', password: '' };
                        loginScope.loading = false;

                        var dialog = ngDialog.open({
                            template: './app/views/aiLoginPopUp.html',
                            className: 'ngdialog-theme-default',
                            scope: loginScope
                        });

                        loginScope.login = function () {
                            if (!loginScope.loginData.email || !loginScope.loginData.password) {
                                toastr.error('Email and password are mandatory!');
                                return;
                            }

                            loginScope.loading = true;

                            ResourceService.login(loginScope.loginData).then(function (data) {
                                localStorageService.set('mail', data.email);
                                localStorageService.set('auth_token', data._id);
                                if (data.role) {
                                    localStorageService.set('role', data.role);
                                }
                                if (data.publisher) {
                                    localStorageService.set('publisher', data.publisher);
                                    $rootScope.templateMaster = true;
                                }
                                localStorageService.set('user', {
                                    firstName: data.firstName,
                                    lastName: data.lastName
                                });
                                $rootScope.userLogged = true;

                                loginScope.loading = false;
                                dialog.close();
                                toastr.success('You are signed in');
                                $scope.generateAi();
                            }, function (error) {
                                loginScope.loading = false;
                                toastr.error(getApiErrorMessage(error, 'Wrong email or password'));
                            });
                        };

                        loginScope.cancel = function () {
                            dialog.close();
                        };
                    }

                    $scope.generateAi = function () {
                        if (!$scope.selected || $scope.generateAiLoading) {
                            return;
                        }

                        if (!AuthenticationService.isLogged()) {
                            openAiLoginDialog();
                            return;
                        }

                        $scope.generateAiLoading = true;

                        ResourceService.replicateGenerate({
                            imageUrl: $scope.url + '/assets' + $scope.selected.image
                        }).then(function (data) {
                            if (data.url) {
                                $scope.screenshots = screenShotStoreSrvc.pushScreenshotToStep($scope.step, data.url);
                                $scope.selected = $scope.screenshots[$scope.screenshots.length - 1];
                            }
                            $scope.generateAiLoading = false;
                        }, function (error) {
                            $scope.generateAiLoading = false;

                            // A stale token (e.g. the user was deleted) comes back
                            // as 401: ask to sign in again instead of failing.
                            if (error && error.status === 401) {
                                localStorageService.remove('auth_token');
                                openAiLoginDialog();
                                return;
                            }

                            toastr.error(getApiErrorMessage(error, 'AI image generation failed'));
                        });
                    };

                    $scope.openAiSettings = function () {
                        var settingsScope = $scope.$new(true);

                        settingsScope.loading = true;
                        settingsScope.saving = false;
                        settingsScope.usesDefaults = false;
                        settingsScope.models = aiSnapshotConstants.ALLOWED_MODELS.slice();
                        settingsScope.maxPromptLength = aiSnapshotConstants.MAX_PROMPT_LENGTH;
                        settingsScope.form = {
                            prompt: aiSnapshotConstants.DEFAULT_PROMPT,
                            model: aiSnapshotConstants.DEFAULT_MODEL
                        };

                        function applyDefaults() {
                            settingsScope.form.prompt = aiSnapshotConstants.DEFAULT_PROMPT;
                            settingsScope.form.model = aiSnapshotConstants.DEFAULT_MODEL;
                            settingsScope.usesDefaults = true;
                        }

                        ResourceService.getAiSnapshotSettings().then(function (data) {
                            settingsScope.form.prompt = data.prompt;
                            settingsScope.form.model = data.model;
                            settingsScope.usesDefaults = !data.updatedAt;
                            settingsScope.loading = false;
                        }, function (error) {
                            applyDefaults();
                            settingsScope.loading = false;
                            toastr.warning('Using default AI settings');
                        });

                        settingsScope.saveAiSettings = function () {
                            if (settingsScope.saving) {
                                return;
                            }

                            var prompt = (settingsScope.form.prompt || '').trim();

                            if (!prompt) {
                                toastr.error('Prompt is required');
                                return;
                            }

                            if (prompt.length > aiSnapshotConstants.MAX_PROMPT_LENGTH) {
                                toastr.error('Prompt exceeds maximum length');
                                return;
                            }

                            settingsScope.saving = true;

                            ResourceService.saveAiSnapshotSettings({
                                prompt: prompt,
                                model: settingsScope.form.model
                            }).then(function (data) {
                                settingsScope.saving = false;
                                settingsScope.usesDefaults = !data.updatedAt;
                                toastr.success('AI settings saved');
                                settingsScope.closeThisDialog();
                            }, function (error) {
                                settingsScope.saving = false;
                                toastr.error(getApiErrorMessage(error, 'Cannot save AI settings'));
                            });
                        };

                        ngDialog.open({
                            scope: settingsScope,
                            disableAnimation: true,
                            className: 'ngdialog-theme-default ai-snapshot-settings-popup',
                            template: './app/views/aiSnapshotSettingsPopUp.html'
                        });
                    };

                }]
        }
    };

    angular.module('valleyCraftApp').directive('screenshotButton', ['screenShotStoreSrvc', '$rootScope', 'constants', directive]);
})();
